import type { ExternalVoicesSearchParams } from "./useExternalVoicesSearchQuery";

export const ACTOR_VOICES_QUERY_KEYS = {
  all: (actorID: string) => ["ACTOR_VOICES", actorID] as const,
  list: (actorID: string) =>
    [...ACTOR_VOICES_QUERY_KEYS.all(actorID), "LIST"] as const,
  detail: (actorID: string, actorVoiceID: string) =>
    [...ACTOR_VOICES_QUERY_KEYS.all(actorID), "DETAIL", actorVoiceID] as const,
  externalVoicesSearch: (params: ExternalVoicesSearchParams) =>
    ["EXTERNAL_VOICES", "SEARCH", params] as const,
} as const;
